export interface Base {
  _functions: any;
  _uniforms: any;
}
export default class ShadersBase {
  _name = 'shadersBase';
    _base: Base = {                   // TODO: define the types of this interface
      _functions: {},
      _uniforms: {},
    };
    _definition = '';
  constructor() {
    // this._name = 'shadersBase';
    // this._base = {
    //   _functions: {},
    //   _uniforms: {},
    // };
    // this._definition = '';
  }

  get name() {
    return this._name;
  }

  set name(name) {
    this._name = name;
  }
}
